export default class EditorHook {
	data = { };

	constructor(i_data) {
		this.data = i_data;
	}
}
